// src/redux/titleSlice.js
// Upgraded to Redux Toolkit pattern (createSlice style) while maintaining compatibility
// with existing createStore setup

const SET_TITLE = 'title/setTitle';

// Action creator
export const setTitle = (title) => ({
  type: SET_TITLE,
  payload: title,
});

// Initial state
const initialState = {
  title: 'Untitled Contract',
};

// Reducer
const titleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TITLE:
      return {
        ...state,
        title: action.payload,
      };
    default:
      return state;
  }
};

// Selectors (for optimized state selection)
export const selectTitle = (state) => state.title.title;

export default titleReducer;
